<template>
  <v-row>

    <v-col cols="12" style="position: relative;">
      
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="closeCreate"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-card-text v-else>
          <v-row class="justify-center">
            <v-col cols="12" md="8">
              <div class="title pl-2">Info</div>
              <v-row no-gutters>
                <v-col cols="12" sm="6" lg="4" class="pa-1">
                  <v-text-field
                    v-model="first_name"
                    label="* First Name"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" class="pa-1">
                  <v-text-field
                    v-model="last_name"
                    label="* Last Name"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" class="pa-1">
                  <v-text-field
                    v-model="mobile_phone"
                    v-mask="phoneMask"
                    label="Mobile Phone"
                    placeholder=" "
                    prepend-inner-icon="mdi-cellphone"
                    outlined
                    hide-details
                    clearable
                    :disabled="saving"
                  />
                </v-col>

                <v-col cols="12" lg="8" class="pa-1">
                  <v-text-field
                    v-model="email"
                    label="* Email"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>

                <v-col 
                  cols="12" 
                  lg="4" 
                  class="pa-1"
                  v-if="!(userId && !$store.getters.userIs('systemAdmin') && (permission == 'employee' || permission == 'systemAdmin'))"
                >
                  <v-select
                    v-model="permission"
                    label="* Permission"
                    outlined
                    :items="permissions"
                    :disabled="saving || (userId && userId == $store.getters.user.id)"
                  />
                </v-col>
            
              </v-row>
            </v-col>
            <v-col cols="12" md="4" v-if="canAssignPartnership">
              <div class="title pl-2">Partner</div>
              <v-row no-gutters>
                <v-col cols="12" class="pa-1">

                  <v-autocomplete
                    v-model="partner"
                    :loading="partnerSearching"
                    :items="partners"
                    :search-input.sync="partnerSearch"
                    outlined
                    hide-details
                    label="Partnership"
                    return-object
                    item-text="name"
                    item-value="id"
                    dense
                    clearable
                    :disabled="saving || (permission == 'employee' || permission == 'systemAdmin')"
                  >
                  </v-autocomplete>

                </v-col>
              </v-row>

              <div class="mt-8 pl-2" v-if="this.userId">
                <div class="title">
                  <v-row no-gutters class="flex-nowrap align-center">
                    <v-col>
                      Subscription
                    </v-col>
                    <v-col v-if="weirdPermissions && isAdminOrEmployee" class="text-right">
                      <v-btn
                        small
                        color="error"
                        :loading="loading || saving"
                        @click="recheckPermissions"
                      >
                        <v-icon small class="mr-2">mdi-alert</v-icon>Re-Check Permissions
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col>
                    <span v-if="user.subscription_status == 'INACTIVE' && permission != 'systemAdmin' && permission != 'employee'">
                      <v-icon class="error--text">mdi-do-not-disturb</v-icon> Inactive
                    </span>
                    <span v-else-if="user.subscription_status == 'ACTIVE' || permission == 'systemAdmin' || permission == 'employee'">
                      <v-icon class="primary--text">mdi-circle</v-icon> Active
                    </span>
                  </v-col>
                  <v-col>
                    <span v-if="user.permissions && user.permissions.indexOf('product_freedom-accelerator') >= 0">
                      <v-icon class="primary--text">mdi-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon class="error--text">mdi-close</v-icon>
                    </span>
                    
                    Freedom Accelerator
                  </v-col>
                </v-row>
              </div>

            </v-col>

          </v-row>
          <v-row class="justify-center px-1">
            <v-col cols="12" md="12">
              <v-col cols="12" lg="8" class="pa-0">
                <v-text-field
                    v-model="company"
                    label="Company"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                />
              </v-col>
              <v-row class="justify-center px-2">
                <v-col cols="8" lg="8" class="pa-1">
                  <v-text-field
                      v-model="address1"
                      label="Address 1"
                      outlined
                      placeholder=" "
                      :disabled="saving"
                  />
                </v-col>
                <v-col cols="4" lg="4" class="pa-1" >
                  <v-select v-model="type" label="Type" outlined :items="types" :disabled="saving" />
                </v-col>
              </v-row>
              <v-row class="justify-center px-2">
                <v-col cols="8" lg="8" class="pa-1">
                  <v-text-field
                      v-model="address2"
                      label="Address 2"
                      outlined
                      placeholder=" "
                      :disabled="saving"
                  />
                </v-col>
                <v-col cols="4" lg="4" class="pa-1" >
                  <v-select v-model="status" label="Status" outlined :items="statuses" :disabled="saving" />
                </v-col>
              </v-row>
              <v-row class="px-2">
                <v-col cols="8" lg="8" class="pa-1">
                  <v-row class="px-2">
                    <v-col cols="4" lg="4" class="pa-1" ><v-text-field
                        v-model="city"
                        label="City"
                        outlined
                        placeholder="City"
                        :disabled="saving"
                    /></v-col>
                    <v-col cols="4" lg="4" class="pa-1" ><v-text-field
                        v-model="state"
                        label="State"
                        outlined
                        placeholder="State"
                        :disabled="saving"
                    /></v-col>
                    <v-col cols="4" lg="4" class="pa-1" ><v-text-field
                        v-model="zipcode"
                        label="Zip Code"
                        outlined
                        placeholder="Zip Code"
                        :disabled="saving"
                    /></v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="px-2">
                <v-col cols="12" lg="4" class="pa-0">
                  <v-text-field
                      v-model="phone"
                      label="Phone"
                      outlined
                      placeholder="Phone"
                      v-mask="phoneMask"
                      prepend-inner-icon="mdi-cellphone"
                      hide-details
                      clearable
                      :disabled="saving"
                  />
                </v-col>
              </v-row>
              <v-row class="px-2">
                <v-col cols="4" lg="4" class="pa-0">
                  <v-radio-group v-model="phone_type" row>
                    <v-radio
                        v-for="type in catalogs.phone_types"
                        :key="type.value"
                        :label="type.text"
                        :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="px-2">
                <v-col cols="3" lg="3" class="pa-0">
                  <v-file-input
                      label="Large Logo Upload"
                      ref="large_logo"
                      @change="downloadLargeLogo"
                  ></v-file-input>
                  <div class="mb-3 ml-8 show-upload-file-size">Suggested size 2168x440 pixels</div>
                </v-col>

                <v-col cols="3" lg="3" class="pa-0">
                  <v-file-input
                      label="Small Logo Upload"
                      ref="small_logo"
                      @change="downloadSmallLogo"
                  ></v-file-input>
                  <div class="mb-3 ml-8 show-upload-file-size">Suggested size 542x110 pixels</div>
                </v-col>
              </v-row>

              <v-row class="px-2">
                <v-col v-if="large_logo" cols="3" lg="3" class="pa-0">
                  <v-img :src="base_url+'logos/'+large_logo" max-width="180" class="mx-auto mb-1" />
                </v-col>
                <v-col v-if="small_logo" cols="3" lg="3" class="pa-0">
                  <v-img :src="base_url+'logos/'+small_logo" max-width="180" class="mx-auto mb-1" />
                </v-col>
              </v-row>

            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn color="primary" :disabled="!saveable" @click="submit" :loading="saving">{{ (userId ? 'Update' : 'Create') }}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const PHONE_TYPES = [{ text: 'Cell', value: 'cell' }, { text: 'Phone', value: 'phone' }];
import { PHONE_MASK } from '@/global/consts.js';
import { processPhoneNumber } from '@/global/helpers.js';

export default {
  name: 'AdminAgentsEdit',
  data: () => ({
    saving: false,
    loading: true,
    user: {},

    first_name: null,
    last_name: null,
    email: null,
    mobile_phone: null,
    partner: null,
    partnerSearching: false,
    partnerSearch: null,
    partners: [],
    partnerSearchTimeout: null,

    company:null,
    address1:null,
    address2:null,
    type:null,
    status:null,
    city:null,
    state:null,
    zipcode:null,
    phone:null,
    phone_type: PHONE_TYPES[0].value,
    catalogs: {
      phone_types: PHONE_TYPES,
    },
    small_logo:null,
    large_logo:null,
    permission: 'agent',
    expansions: 'partnership,role,permissions,meta',

    phoneMask: PHONE_MASK,
    base_url: process.env.VUE_APP_API_BASE_URL
  }),
  mounted () {
    this.getDataFromApi()
  },
  watch: {
    userId () {
      this.getDataFromApi()
    },
    partnerSearch () {
      let ref = this
      if(this.partnerSearchTimeout) clearTimeout(this.partnerSearchTimeout)
      this.partnerSearchTimeout = setTimeout(function() {
        ref.getPartnerDataFromApi()
      }, 300)
    },
    partner (newVal) {
      if(!newVal && this.permission == 'partnershipAdmin') this.permission = 'agent'
    }
  },
  computed: {
    userId () {
      return this.$route.params.user_id
    },
    saveable() {
      if( this.first_name &&
          this.last_name  &&
          this.email &&
          this.permission
      ) return true
      return false
    },
    isAdminOrEmployee () {
      return (
        this.$store.getters.userIs('systemAdmin') ||
        this.$store.getters.userIs('employee')
      )
    },
    types (){
      let arr = [];
      arr.push({text: 'IMO', value: 'imo'});
      return arr;
    },
    statuses (){
      let arr = [];
      arr.push({text: 'Active', value: '1'});
      arr.push({text: 'Disabled', value: '0'});
      return arr;
    },
    permissions () {
      let arr = []
      arr.push({text: 'Agent', value: 'agent'})
      if( this.isAdminOrEmployee )
      {
        if(this.partner) {
          arr.push({text: 'Admin', value: 'partnershipAdmin'})
        }
        if(this.$store.getters.userIs('systemAdmin')) {
          arr.push({text: 'Employee', value: 'employee'})
          arr.push({text: 'System Admin', value: 'systemAdmin'})
        }
      } else if(this.$store.getters.userIs('partnershipAdmin')) {
        arr.push({text: 'Admin', value: 'partnershipAdmin'})
      }
      
      return arr
    },
    canAssignPartnership () {
      return ( this.isAdminOrEmployee )
    },
    freedomAccelerator() {
      return (this.user.permissions && this.user.permissions.indexOf('product_freedom-accelerator') >= 0)
    },
    weirdPermissions() {
      return this.userId && this.user.subscription_status == 'ACTIVE' && !this.freedomAccelerator;
    }
  },
  methods: {
    downloadLargeLogo(file) {
      if (!file) {
        return;
      }
      const formData = new FormData();
      formData.append('document', file);

      let requestUrl = (this.userId ? 'users/logo-upload' : '')

      this.$http({
        method: 'post',
        url:    requestUrl,
        data:   formData
      })
      .then(response => {
        this.large_logo = response.data; })

      .catch(err => {
        console.log(err.response)
        this.$swal.fire('Error', 'There was a problem saving the logo', 'error')
      })
    },
    downloadSmallLogo(file) {
      if (!file) {
        return;
      }
      const formData = new FormData();
      formData.append('document', file);

      let requestUrl = (this.userId ? 'users/logo-upload' : '')

      this.$http({
        method: 'post',
        url:    requestUrl,
        data:   formData
      })
          .then(response => {
            this.small_logo = response.data;
            console.log(response.data)
          })

          .catch(err => {
            console.log(err.response)
            this.$swal.fire('Error', 'There was a problem saving the logo', 'error')
          })
    },
    submit() {
      if(!this.saveable) return
      this.saving = true

      let data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        mobile_phone: processPhoneNumber(this.mobile_phone),
        mobile_phone_country: (this.mobile_phone ? 'US' : null),
        type: 'AGENT',
        changeRole: this.permission,
        alertOnCreate: true,
        meta_data: {
          company: this.company,
          address1: this.address1,
          address2: this.address2,
          data_type: this.type,
          status: this.status,
          city: this.city,
          state: this.state,
          zipcode: this.zipcode,
          phone: this.phone,
          phone_type: this.phone_type,
          small_logo: this.small_logo,
          large_logo: this.large_logo
        }
      }

      if(this.canAssignPartnership && this.permission == 'agent' || this.permission == 'partnershipAdmin') {
        data.partnership_id = (this.partner ? this.partner.id : null)
      }

      if(!this.userId) data.status = 10

      let requestType = (this.userId ? 'put' : 'post')
      let requestUrl = (this.userId ? 'users/' + this.userId + '?expand=' + this.expansions : 'users?expand=' + this.expansions)

      this.$http({
        method: requestType,
        url:    requestUrl,
        data:   data
      })
        .then(response => {
          this.user   = response.data
          if(!this.userId) this.$router.push({name: 'partnership-admin-agents-edit', params:{user_id: response.data.id}})
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was a problem saving the user', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
    recheckPermissions() {
      if(!this.userId) return
      if(!this.isAdminOrEmployee) return
      this.saving = true

      this.$http.post('users/' + this.userId + '/validate-subscription?expand=' + this.expansions)
        .then(response => {
          this.user   = response.data
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was a problem validating this users permissions', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
    closeCreate () {
      if(this.dialog) {
        this.$emit('on-close')
      } else {
        this.$router.push({name: 'partnership-admin-agents'})
      }
    },

    getDataFromApi() {
      if(!this.userId) {
        this.loading = false
        return
      }
      this.loading = true
      let qParams = []
      qParams.push('expand=' + this.expansions)
      this.$http.get('users/' + this.userId + '?' + qParams.join('&'))
        .then(response => {
          this.user                     = response.data

          this.first_name               = response.data.first_name
          this.last_name                = response.data.last_name
          this.email                    = response.data.email
          this.mobile_phone             = response.data.mobile_phone
          this.mobile_phone_country     = (response.data.mobile_phone ? 'US' : null)
          this.partner                  = response.data.partnership
          this.partners                 = (response.data.partnership ? [response.data.partnership] : [])
          this.permission               = response.data.role
          this.company                  = response.data.meta.company
          this.address1                 = response.data.meta.address1
          this.address2                 = response.data.meta.address2
          this.type                     = response.data.meta.data_type
          this.status                   = response.data.meta.status
          this.city                     = response.data.meta.city
          this.state                    = response.data.meta.state
          this.zipcode                  = response.data.meta.zipcode
          this.phone                    = response.data.meta.phone
          this.phone_type               = response.data.meta.phone_type
          this.small_logo               = response.data.meta.small_logo
          this.large_logo               = response.data.meta.large_logo
          this.loading = false
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading user info', 'error')
        })
    },

    getPartnerDataFromApi () {
      let queryParams = []

      this.partnerSearching = true
      if(this.partnerSearch) queryParams.push('s=' + encodeURIComponent(this.partnerSearch) )

      this.$http.get('partnerships?' + queryParams.join('&'))
        .then(response => {
          this.partners = response.data.items
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading partnerships', 'error')
        })
        .finally(() => {
          this.partnerSearching = false
        })
    }
  }
}
</script>

<style lang="scss">
  .desiredOutcomesTextarea {
    textarea {
      resize: none;
      margin-top: 2px !important;
    }
  }
</style>